export const getValue = (obj) => Object.values(obj)[0];
